import CryptoJS from "crypto-js";
import { ArchiveService } from "../WebApiServices/Archive.service";
import ArchiveModel from "../DataModels/ArchiveModel";
import { DatePart, Values, Role } from "./Enums";
import moment from "moment";
const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_KEY);
const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_KEY);


/* <summary>
date: 06-04-2024
Name: AP
description: Get logged in user's ID
<summary>*/
export const GetLoggedInUserID = () => {
  const userId = GetLocalStorageData("userId");
  return Number(userId);
};

/* <summary>
date: 06-04-2024
Name: AP
description: Add data to local storage in encrypted form
<summary>*/
export const AddLocalStorageData = (storageKey, value) => {

  const encryptedValue = EncryptUsingAES256(JSON.stringify(value));
  const encryptedKey = EncryptUsingAES256(storageKey);
  if (localStorage.getItem(storageKey)) {
    localStorage.removeItem(storageKey);
  }
  localStorage.setItem(encryptedKey, encryptedValue);
};

/* <summary>
date: 06-04-2024
Name: AP
description: get decrypted data from local storage
<summary>*/
export const GetLocalStorageData = (storageKey) => {

  const encryptedKey = EncryptUsingAES256(storageKey);
  const encryptedValue = localStorage.getItem(encryptedKey) ?? undefined;
  try {
    if (encryptedValue) {
      return JSON.parse(DecryptUsingAES256(encryptedValue));
    }
  } catch (error) { }
  return encryptedValue;
};

/* <summary>
date: 06-04-2024
Name: AP
description: get decrypted data from local storage
<summary>*/
export const RemoveLocalStorageData = (storageKey) => {
  const encryptedKey = EncryptUsingAES256(storageKey);
  localStorage.removeItem(encryptedKey);
};

/* <summary>
date: 06-04-2024
Name: AP
description: Check if string is empty/undefined/null
<summary>*/
export const isStringEmpty = (text) => {

  //try {
  return !text || text.trim().length === 0;
  // } catch (error) {
  // }
};

/* <summary>
date: 06-04-2024
Name: AP
description: Encryption using CryptoJS
<summary>*/
export const EncryptUsingAES256 = (text) => {
  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key, {
    iv,
    keySize: 128 / 8,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

/* <summary>
date: 06-04-2024
Name: AP
description: Decryption using CryptoJS
<summary>*/
export const DecryptUsingAES256 = (decString) => {
  const decrypted = CryptoJS.AES.decrypt(decString, key, {
    iv,
    keySize: 128 / 8,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};
/* <summary>
date: 06-04-2024
Name: AP
description: Email Validation
<summary>*/
// export const IsEmailValid = (emailAddress) => {
//   const emailRegexString =
//     /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
//   ///^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/; from other ag projects
//   return emailRegexString.test(emailAddress);
// };
//ST: Sonar Security hotspot fix
export const IsEmailValid = (emailAddress) => {
  if (typeof emailAddress !== 'string') {
    return false;
  }

  // Split the email into parts
  const parts = emailAddress.split('@');

  // Ensure there are exactly two parts
  if (parts.length !== Values.value2) {
    return false;
  }

  const [localPart, domainPart] = parts;

  // Ensure the local part and domain part are non-empty
  if (!localPart || !domainPart) {
    return false;
  }

  // Ensure the domain part contains at least one period
  if (!domainPart.includes('.')) {
    return false;
  }

  return true;
};
/* <summary>
date: 06-04-2024
Name: AP
description: Validates password
<summary>*/
// export const IsPasswordValid = (passowrd) => {
//   const passwordRegexString = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/;
//   return passwordRegexString.test(passowrd);
// };
//ST: Sonar Security hotspot fix
//export const IsPasswordValid = (password) => {
// if (typeof password !== 'string') return false;

// // Rule 1: Length of at least 8 characters
// if (password.length < 8) return false;

// // Rule 2: At least one lowercase letter
// if (!/[a-z]/.test(password)) return false;

// // Rule 3: At least one uppercase letter
// if (!/[A-Z]/.test(password)) return false;

// // Rule 4: At least one digit
// if (!/\d/.test(password)) return false;

// // Rule 5: At least one special character
// if (!/\W/.test(password)) return false;

// return true;
//};
export const IsPasswordValid = (password) =>
  typeof password === 'string' &&
  password.length >= 8 && password.length < 65 &&
  /[a-z]/.test(password) &&
  /[A-Z]/.test(password) &&
  /\d/.test(password) &&
  /\W/.test(password);


/* <summary>
date: 06-04-2024
Name: AP
description: Common fn calling archive service to add archive
<summary>*/
export const AddArchiveFunction = (actionNumber, data, userId, secondaryId) => {
  const payLoad = new ArchiveModel();
  payLoad.archiveaction = actionNumber;
  payLoad.archivedata = data;
  payLoad.userid = userId;
  payLoad.secondaryid = secondaryId;
  //payLoad.CreatedBy = userId;

  ArchiveService.AddArchive(payLoad);
};


//Allow only positive integers
//Value being passed shouldn't be blank
export const AllowOnlyIntegers = (value) => {
  const NUMBER_REGEX = /^(?:\d+)?$/;// /^[0-9\b]+$/;
  return NUMBER_REGEX.test(value)
}
//Allow only positive Decimals max 1 place 
export const AllowNumberWithOneDecimal = (value) => {
  const NUMBER_REGEX = /^[+]?\d*\.?\d{0,1}$/;
  return NUMBER_REGEX.test(value);
}
//Allow only positive Decimals max 2 place 
export const AllowNumberWithTwoDecimal = (value) => {
  const NUMBER_REGEX = /^[+]?\d*\.?\d{0,2}$/;
  return NUMBER_REGEX.test(value);
}

//Allow only positive Decimals max 2 places
// export const AllowPositiveDecimalNumbers = (value) => {
//   // const NUMBER_REGEX = /^[0-9]*(\.[0-9]{0,2})?$/;
//   const NUMBER_REGEX = /^(0|[1-9][0-9]*)(\.[0-9]{1,2})?$/;

//   return NUMBER_REGEX.test(value)
// }
export const AllowPositiveDecimalNumbers = (value) => {
  // Ensure the value is a string and handle empty input
  if (typeof value !== 'string' || value.trim() === '') {
    return false;
  }

  // Split the value into integer and decimal parts
  const parts = value.split('.');

  // Check if the integer part is a valid number and positive
  const integerPart = parts[0];
  if (!/^[0-9]+$/.test(integerPart) || parseInt(integerPart, 10) < 0) {
    return false;
  }

  // If there is a decimal part, check if it's valid (0-2 digits)
  if (parts.length === Values.value2) {
    const decimalPart = parts[1];
    if (decimalPart.length > Values.value2 || !/^[0-9]+$/.test(decimalPart)) {
      return false;
    }
  }
  return true;
};
/* <summary>
date: 07-06-2024
Name: AP
description: Sets the state for the date control
params: date: current date state value, value: used to update, datePart: D/M/Y
<summary>*/
export const SetDateState = (date, value, datePart) => {

  const parts = date?.split('/') ?? [];
  let month = parts[0] ?? "";
  let day = parts[1] ?? "";
  let year = parts[2] ?? "";

  // const parts = date.split('/');
  // let month = parts[0];
  // let day = parts[1];
  // let year = parts[2];

  if (datePart === DatePart.Day) {
    day = value;
  }
  else if (datePart === DatePart.Month) {
    month = value;
  }
  else if (datePart === DatePart.Year) {
    year = value;
  }

  const formattedDate = `${month}/${day}/${year}`;
  return formattedDate;
}
/* <summary>
date: 07-06-2024
Name: AP
description: Handles UNK selection in date. Returns absolute date
<summary>*/
export const ParseDate = (dateStr) => {
  const parts = dateStr.split('/');
  let month = parts[0];
  let day = parts[1];
  const year = parts[2];

  if (day === "UNK" && month === "UNK") {
    day = "01";
    month = "07";
  } else if (day === "UNK") {
    day = "15";
  } else if (month === "UNK") {
    month = "06";
  }
  const formattedDate = `${month}/${day}/${year}`;
  return formattedDate;
}
/* <summary>
date: 07-06-2024
Name: AP
description: Checks if date is empty or contains any default value in day month year dropdown
<summary>*/
export const IsDateEmpty = (date) => {
  return isStringEmpty(date) || date.includes("MM") || date.includes("DD") || date.includes("YYYY");
}
/* <summary>
date: 07-06-2024
Name: AP
description: Checks if date exists. If UNK is selected return true
<summary>*/

export function IsDtValid(date) {
  if (date === "Invalid Date") {
    return false;
  }
  else {
    return true;
  }
};
/* <summary>
date: 08-01-2025
Name: AP
description: Checks if date is non-existent or not within the specified range
Default min 1st Jan 1920, max chart abstraction date
<summary>*/
export const IsDateValid = (date, minDt, maxDt) => {
  if (date === "Invalid Date") {
    return false;
  }
  if (!minDt) {
    minDt = "01-01-1920";
  }
  if (!maxDt) {
    maxDt = GetChartDateStr();
  }
  const dateObj = new Date(date);
  const minDtObj = new Date(minDt);
  const maxDtObj = new Date(maxDt);
  return minDtObj && maxDtObj &&
    minDtObj <= dateObj && dateObj <= maxDtObj;
};


export const DateValid = (date, maxDt) => {

  if (date === "Invalid Date") {
    return false;
  }

  if (!maxDt) {
    return false
  }
  const dateObj = new Date(date);
  const maxDtObj = new Date(maxDt);

  return maxDtObj &&
    dateObj <= maxDtObj;
};

export const ValidateFourDates = (preTransplantStart, admissionDate, dischargeDate, postStabilizationDate) => {
  const preTransplantObj = new Date(preTransplantStart);
  const admissionObj = new Date(admissionDate);
  const dischargeObj = new Date(dischargeDate);
  const postStabilizationObj = new Date(postStabilizationDate);

  // Check if any date is invalid
  if ([preTransplantObj, admissionObj, dischargeObj, postStabilizationObj].some(date => isNaN(date.getTime()))) {
    return false;
  }

  // Check the order of dates
  return preTransplantObj <= admissionObj &&
         admissionObj <= dischargeObj &&
         dischargeObj <= postStabilizationObj;
};

// export const ValidateThreeDates = (mdeStartDate, assessmentDate, mdeEndDate) => {

//    // Convert all dates to Date objects
//    const startObj = new Date(mdeStartDate);
//    const endObj = new Date(mdeEndDate);
//    const assessmentObj = new Date(assessmentDate);
 
//    // Check if any date is invalid
//    if (isNaN(startObj.getTime()) || isNaN(endObj.getTime()) || isNaN(assessmentObj.getTime())) {
//      return false;
//    }
 
//    // Check if assessmentDate is within the range
//    return startObj <= assessmentObj && assessmentObj <= endObj;
// };
export const ValidateThreeDates = (mdeStartDate, assessmentDate, mdeEndDate) => {
  // Normalize to YYYY-MM-DD for all inputs
  const normalizeDate = (dateStr) => {
    if (!dateStr) return null;

    // Detect if it's in MM/DD/YYYY format
    if (dateStr.includes("/")) {
      const [month, day, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day); // month is 0-based
    }

    // If it's already YYYY-MM-DD
    if (dateStr.includes("-")) {
      const [year, month, day] = dateStr.split("-").map(Number);
      return new Date(year, month - 1, day);
    }

    return null;
  };

  const startObj = normalizeDate(mdeStartDate);
  const assessmentObj = normalizeDate(assessmentDate);
  const endObj = normalizeDate(mdeEndDate);
 
   // Check if any date is invalid
  if (!startObj || !assessmentObj || !endObj) {
     return false;
   }
 
  // Compare without time part
   return startObj <= assessmentObj && assessmentObj <= endObj;
};



/* <summary>
date: 09-01-2025
Name: AP
description: Get Chart Abstraction Date of patient
<summary>*/
export const GetChartDateStr = () => {
  let patientData = GetLocalStorageData("patient");
  patientData = patientData && JSON.parse(patientData);
  const surveyDate = patientData?.surveyDate;
  return surveyDate;
};
/* <summary>
date: 20-10-2023
Name: AP
description: Subtract months from date
<summary>*/
export const SubtractMonths = (dateStr, months) => {
  if (!dateStr) {
    return null;
  }
  const momentDate = moment(dateStr, "MM/DD/YYYY");
  if (!momentDate.isValid()) {
    return null;
  }
  return momentDate.subtract(months, 'months').toDate();
}
/* <summary>
date: 20-10-2023
Name: AP
description: Format date to display
<summary>*/
export const DateDisplayFormat = (date) => {
  const momentDate = moment(date);

  if (momentDate.isValid()) {
    const month = momentDate.format('MM');
    const day = momentDate.format('DD');
    const year = momentDate.format('YYYY');

    return `${month}/${day}/${year}`;
  } else {
    return false;
  }
}
/* <summary>
date: 11-06-2024
Name: NN
description: Check if age greater than equal to 18
<summary>*/
export const IsAge18 = (dob, referenceDate) => {

  if (!dob || !referenceDate) {
    return false;
  }

  // Parse dates to handle "UNK" values
  const parsedDob = ParseDate(dob);
  const parsedReferenceDate = ParseDate(referenceDate);

  const birthDate = moment(parsedDob, "MM/DD/YYYY");
  const refDate = moment(parsedReferenceDate, "MM/DD/YYYY");

  if (!birthDate.isValid() || !refDate.isValid()) {
    return false;
  }

  const age = refDate.diff(birthDate, 'years', true); // The true parameter returns the difference as a float
  return age >= 18;
};

/* <summary>
date: 11-06-2024
Name: AP
description: Gets the ordinal value of a number
<summary>*/
export const GetOrdinal = (n) => {
  let suffix;
  const lastDigit = n % 10;
  const lastTwoDigits = n % 100;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    suffix = "th";
  } else {
    switch (lastDigit) {
      case 1:
        suffix = "st";
        break;
      case 2:
        suffix = "nd";
        break;
      case 3:
        suffix = "rd";
        break;
      default:
        suffix = "th";
        break;
    }
  }
  return <span>{n}<sup>{suffix}</sup></span>;
};

/* <summary>
date: 11-06-2024
Name: AP
description: Gets the ordinal value of a number in text format
<summary>*/
export const GetOrdinalInWord = (num) => {
  const ordinals = [
    "first", "second", "third", "fourth",
    "fifth", "sixth", "seventh", "eighth", "ninth", "tenth"
  ];
  if (num > 0 && num < 11) {
    return ordinals[num - 1];
  } else {
    return `${num}th`;
  }
};

//Check if value is within allowed bounds. Both the bounds are inclusive
export const ValueInRange = (value, lowLim, highLim) => {
  return lowLim <= value && value <= highLim;
}

// Function to display selected items as comma-separated text
// list of selected checkboxes and their associated text
export const DisplaySelectedText = (list) => {
  const sortedKeys = Array.from(list.keys()).sort((a, b) => a - b);
  const orderedValues = sortedKeys.map(key => list.get(key));
  return orderedValues.join(', ');
};

export const GetDifferenceInDays = (date1, date2) => {
  const dateObj1 = new Date(date1);
  const dateObj2 = new Date(date2);

  const timeDiff = Math.abs(dateObj1 - dateObj2);
  const diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  return diffDays; // Convert milliseconds to days
};

export const IsDateBefore = (date1, date2) => {
  const dateObj1 = new Date(date1);
  const dateObj2 = new Date(date2);

  if (dateObj1 < dateObj2)
    return true; // Convert milliseconds to days
  else
    return false;
};


export const IsGreaterOrEqual = (date1, date2) => {

  if(!date2){
    return false;
  }
  const dateObj1 = new Date(date1);
  const dateObj2 = new Date(date2);

  if (dateObj1 >= dateObj2)
    return true; // Convert milliseconds to days
  else
    return false;
};

export const IsDateAfter = (date1, date2) => {
  const dateObj1 = new Date(date1);
  const dateObj2 = new Date(date2);

  if (dateObj1 > dateObj2)
    return true; // Convert milliseconds to days
  else
    return false;
};

export const IsDateBeforeMinus22Days = (date1, date2) => {
  const dateObj1 = new Date(date1);
  const dateObj2 = new Date(date2);

  const dateObj2Minuss22Days = dateObj2.setDate(dateObj2.getDate() - 22);
  if (dateObj1 < dateObj2Minuss22Days)
    return true; // Convert milliseconds to days
  else
    return false;
};

export const IsDateBetween = (date1, date2, date3) => {
  const dateObj1 = new Date(date1);
  const dateEntered = new Date(date2);
  const dateObj3 = new Date(date3);


  if (dateEntered > dateObj1 && dateEntered < dateObj3) {

    return true;
  }
  else {

    return false;
  }
};

export const getOrdinalSuffix = (index) => {
  const j = index % 10;
  const k = index % 100;

  if (j === 1 && k !== 11) {
    return (
      <>
        {index}
        <sup>st</sup>
      </>
    );
  }
  if (j === Values.value2 && k !== 12) {
    return (
      <>
        {index}
        <sup>nd</sup>
      </>
    );
  }
  if (j === Values.value3 && k !== 13) {
    return (
      <>
        {index}
        <sup>rd</sup>
      </>
    );
  }
  return (
    <>
      {index}
      <sup>th</sup>
    </>
  );
};
/* <summary>
date: 10-10-2024
Name: AP
description: Checks if a word is found in a word list
<summary>*/
export const MatchesAnyWord = (inputStr, wordList) => {

  return wordList.some(w => w.toLowerCase() === inputStr.toLowerCase());
}
/* <summary>
date: 02-11-2024
Name: AP
description: Add/Minus days from date
<summary>*/
export const AdjustDays = (dateStr, days) => {
  if (!dateStr) {
    return null;
  }
  let date = new Date(dateStr);
  date.setDate(date.getDate() + days);
  if (date) {
    return DisplayFormat(date);
  };
  return null;
}

//https://ideawharf.sifterapp.com/issues/12821
//ST: 12/11/2024: Function to add alphabet after the question
export const GetAlphabetSuffix = (index) => {
  const alphabet = "abcdefghijklmnopqrstuvwxyz";

  // Use modulo to wrap around the alphabet if index exceeds 26
  const letter = alphabet[(index - 1) % alphabet.length];  // Ensure wrapping within the alphabet length

  return (
    <>
      {letter}
    </>
  );
};
/* <summary>
date: 07-01-2025
Name: AP
description: Check if date exists
<summary>*/
export const IsDateInvalid = (date) => {
  if (date === "Invalid Date") {
    return true;
  }
  return false;
};
export const DisplayFormat = (date) => {
  if (date instanceof Date && !isNaN(date)) {
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get the month (0-11) and add 1, then pad with '0'
    const day = String(date.getDate()).padStart(2, '0'); // Get the day of the month and pad with '0'
    const year = date.getFullYear(); // Get the year
    return `${month}/${day}/${year}`;
  } else return null;
}
export const GetEarliestDate = (date1, date2, date3) => {

  const dates = [date1, date2, date3];
  // Filter out null/undefined dates, convert to Date obj, filter invalid ones
  const validDates = dates.filter(date => date).map(date => new Date(date)).filter(date => IsValidDate(date));
  if (validDates.length > 0) {
    const minDate = new Date(Math.min(...validDates));
    if (minDate) {
      return DisplayFormat(minDate);
    };
  }
  return null;
}

export const GetEarlierOfDate = (date1, date2, date3, date4) => {

  const dates = [date1, date2, date3, date4];
  // Filter out null/undefined dates, convert to Date obj, filter invalid ones
  const validDates = dates.filter(date => date).map(date => new Date(date)).filter(date => IsValidDate(date));
  if (validDates.length > 0) {
    const minDate = new Date(Math.min(...validDates));
    if (minDate) {
      return DisplayFormat(minDate);
    };
  }
  return null;
}

const IsValidDate = (date) => {
  return date instanceof Date && !isNaN(date);
}
/* <summary>
date: 29-10-2024
Name: AP
description: Checks if logged in user is Admin
<summary>*/
export function IsAdmin() {
  let userDetails = GetLocalStorageData("user")
  userDetails = userDetails && JSON.parse(userDetails);
  const roleId = userDetails?.userRole ?? 0;
  const isAdmin = roleId === Role.Admin ?? false;
  return isAdmin;
}


export const IsValid = (date1, date2, date3, date4) => {
  if (!date1 || !date2 || !date3 || !date4) {
    return false;
  }

  if (date1 === "Invalid Date") {
    return false;
  }
  // if (!date1) {
  //   date1 = "01-01-1920";
  // }

  const date1Obj = new Date(date1);
  const date2Obj = new Date(date2);
  const date3Obj = new Date(date3);
  const date4Obj = new Date(date4);

  // Check if any date is invalid
  if (isNaN(date1Obj) || isNaN(date2Obj) || isNaN(date3Obj) || isNaN(date4Obj)) {
    return false;
  }

  return date1Obj <= date2Obj && date2Obj <= date3Obj && date3Obj <= date4Obj;
};


export const IsDateInRange = (date1, date2, date3, date4) => {
  const date1Obj = new Date(date1);
  const date2Obj = new Date(date2);
  const date3Obj = new Date(date3);
  const date4Obj = new Date(date4);

  if (date1 === "Invalid Date") {
    return false;
  }

  // Check if any date is invalid
  if (
    isNaN(date1Obj) ||
    isNaN(date2Obj) ||
    isNaN(date3Obj) ||
    isNaN(date4Obj)
  ) {
    return false;
  }

  // if (!date1) {
  //   date1 = "01-01-1920";
  // }

  return date1Obj >= date2Obj &&
    date1Obj >= date3Obj &&
    date1Obj <= date4Obj;
};

export const toggleSidebar = (isSideMenuActive, setisSideMenuActive) => {
  const sidebar = document.getElementById("mySidebar");
  const main = document.getElementById("main");
  // const contentsec = document.getElementById("contentsec");

  if (!sidebar || !main
    // || !contentsec
  ) return;

  if (isSideMenuActive) {
    sidebar.style.width = "0";
    main.style.marginLeft = "0";
    setisSideMenuActive(false);
    // contentsec.classList.add("container"); // Add class
  } else {
    sidebar.style.width = "350px";
    main.style.marginLeft = "350px";
    setisSideMenuActive(true);
    // contentsec.classList.remove("container"); // Remove class
  }
};

export const applySidebarState = (isSideMenuActive) => {
  const sidebar = document.getElementById("mySidebar");
  const main = document.getElementById("main");

  if (!sidebar || !main) return;

  if (isSideMenuActive) {
    sidebar.style.width = "350px";
    main.style.marginLeft = "350px";
  } else {
    sidebar.style.width = "0";
    main.style.marginLeft = "0";
  }
};


export const IsValidRange = (date1, date2, date3) => {
  if (!date1 || !date2 || !date3) {
    return false;
  }

  const date1Obj = new Date(date1);
  const date2Obj = new Date(date2);
  const date3Obj = new Date(date3);


  // Check if any date is invalid
  if (isNaN(date1Obj) || isNaN(date2Obj) || isNaN(date3Obj)) {
    return false;
  }

  return date1Obj <= date2Obj && date2Obj <= date3Obj
};

//SYJ - Allows numbers with up to 2 decimal places
export const AllowOnlyNumbersWithTwoDecimals = (value) => {
  const NUMBER_REGEX = /^\d*\.?\d{0,2}$/;
  return NUMBER_REGEX.test(value);
};

export const formatDate = (dateString) => {
  return dateString
    ? (() => {
      const [year, month, day] = dateString.split("T")[0].split("-");
      return `${month}/${day}/${year}`;
    })()
    : null;
};

//SYJ - 28/03/2025 - Comman function to check Max Date
export const GetMaxDate = (date1, date2, date3) => {

  const dates = [date1, date2, date3];
  // Filter out null/undefined dates, convert to Date obj, filter invalid ones
  const validDates = dates.filter(date => date).map(date => new Date(date)).filter(date => IsValidDate(date));
  if (validDates.length > 0) {
    const minDate = new Date(Math.max(...validDates));
    if (minDate) {
      return DisplayFormat(minDate);
    };
  }
  return null;
}